import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const getExistsItemList = createAsyncThunk(
  'canteen-exists-item-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}canteen/item-exists-list`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const itemList = createAsyncThunk('canteen-item-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}canteen/item-list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeItem = createAsyncThunk('canteen-item-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}canteen/item-store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editItem = createAsyncThunk('canteen-item-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}canteen/item-edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getItemUnits = createAsyncThunk('canteen-item-units', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}canteen/item-units`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const itemStockList = createAsyncThunk('canteen-item-stock-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}canteen/item-stock-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const cashTransferList = createAsyncThunk(
  'canteen-cash-transfer-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}canteen/cash-transfer-list`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const cashTransferApprove = createAsyncThunk(
  'canteen-cash-transfer-approve',
  async (date: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}canteen/cash-transfer-approve/` + date)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type ItemState = {
  errors: any
}

const initialState: ItemState = {
  errors: '',
}

export const itemSlice = createSlice({
  name: 'item',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeItem.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = itemSlice.actions
export default itemSlice.reducer
